import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {SupportedLocale} from '@/initializers/i18next';
import {formatFullName, Options} from '@/utils/document/format-name';

export function useFormatFullName() {
  const {i18n} = useTranslation();

  const locale = i18n.language as SupportedLocale;

  return useCallback(
    (firstName: string, lastName: string, options?: Options) =>
      formatFullName(firstName, lastName, {locale, ...options}),
    [locale],
  );
}
